import React, { useCallback, useState } from 'react';

import { toTitle } from '../../base2/utils';

import { PersonSelectOption } from './person-select-option';

interface Person {
  id: string;
  firstName: string;
  lastName: string;
  relationship?: string;
}

interface PersonSelectProps {
  id?: string;
  selected: Person | null;
  handleSelect: (person: Person) => void;
  options: Person[];
  handleClickableOption: () => void;
}

export function PersonSelect({ 
  id,
  selected, 
  handleSelect, 
  options, 
  handleClickableOption 
}: PersonSelectProps) {
  const [ open, setOpen ] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [ open ]);

  const handleSelectOption = useCallback(
    (option: Person) => {
      console.log('Selected option:', option);
      handleSelect(option);
      setOpen(false);
    },
    [ handleSelect ]
  );

  const availableOptions = options.filter(
    (option) => option.id !== selected?.id
  );

  const style = {
    display: open ? 'flex' : 'none',
  };

  return (
    <div className="person-select">
      <input type="hidden" id={id} name={id} value={selected?.id || ''} />
      <div className="person-selected-option" onClick={handleClick}>
        {selected ? (
          <PersonSelectOption
            text={`${selected.firstName} ${selected.lastName}`}
            relationship={selected.relationship ?? 'not specified'}
          />
        ) : (
          <PersonSelectOption
            text="Select a person"
            grayedOut={true}
          />
        )}
        {
          open ?
            <span className="material-symbols-outlined indicator">
              keyboard_arrow_down
            </span>
            :
            <span className="material-symbols-outlined indicator">
              keyboard_arrow_up
            </span>
        }
      </div>
      <div className="person-select-options" style={style}>
        {availableOptions.map((person) => (
          <PersonSelectOption
            id={person.id}
            key={person.id}
            text={toTitle(`${person.firstName} ${person.lastName}`)}
            relationship={person.relationship ?? 'not specified'}
            handleClick={() => handleSelectOption(person)}
          />
        ))}
        <div style={{ height: 0, border: 'solid 1px cornflowerblue' }}></div>
        <PersonSelectOption
          icon="person_add"
          text="Add a new person"
          handleClick={handleClickableOption}
        />
      </div>
    </div>
  );
}
